import {
  BILLING_DEFAULT_PAGE,
  BILLING_DEFAULT_PAGE_SIZE,
} from "../constants/billingEndpoints";
import { unwrapPayload } from "./response";

export const buildPaginationRequest = ({
  page = BILLING_DEFAULT_PAGE,
  pageSize = BILLING_DEFAULT_PAGE_SIZE,
  orderBy = "id",
  extra = {},
} = {}) => ({
  page_number: Number(page) || BILLING_DEFAULT_PAGE,
  page_size: Number(pageSize) || BILLING_DEFAULT_PAGE_SIZE,
  order_by: orderBy,
  ...extra,
});

export const getTotalPages = (payload, fallbackLength = 0, pageSize = 10) => {
  const normalizedPayload = unwrapPayload(payload);
  const paginationSources = [
    normalizedPayload,
    normalizedPayload?.meta,
    normalizedPayload?.pagination,
    normalizedPayload?.pageable,
  ].filter(Boolean);

  const candidates = [
    ...paginationSources.flatMap((source) => [
      source?.total_pages,
      source?.totalPages,
      source?.totalPage,
      source?.pages,
      source?.page_count,
    ]),
  ];

  const firstPositivePageCount = candidates.find(
    (value) => Number.isFinite(Number(value)) && Number(value) > 0
  );

  if (firstPositivePageCount) {
    return Number(firstPositivePageCount);
  }

  const totalItems = [
    ...paginationSources.flatMap((source) => [
      source?.total_items,
      source?.totalItems,
      source?.total_count,
      source?.totalCount,
      source?.count,
    ]),
  ].find((value) => Number.isFinite(Number(value)) && Number(value) >= 0);

  if (Number.isFinite(Number(totalItems)) && Number(totalItems) > 0) {
    return Math.max(1, Math.ceil(Number(totalItems) / Math.max(pageSize, 1)));
  }

  return fallbackLength > 0 ? 1 : 0;
};
